import { connect } from 'react-redux';
import * as selectors from '../state/selectors';
import { filterEntitiesByAvailableFeatures as _filterEntitiesByAvailableFeatures, isFeatureEnabled as _isFeatureEnabled } from '../utils';

var mapStateToProps = function mapStateToProps(state) {
  var features = selectors.featuresSelector(state);
  return {
    features: features,
    isFeatureEnabled: function isFeatureEnabled(feature) {
      if (!features) {
        return false;
      }

      return _isFeatureEnabled(feature, features);
    },
    filterEntitiesByAvailableFeatures: function filterEntitiesByAvailableFeatures(entities) {
      if (!features) {
        return entities;
      }

      return _filterEntitiesByAvailableFeatures(entities, features);
    }
  };
};

export default connect(mapStateToProps);